module.exports = __webpack_public_path__ + "img/something-went-wrong.44a22278.svg";